export default {
    PUT_CHAT: (state, data) => {
        if(data.text?.length > 0){
            state.chatList.push(data)
        }
    },
    SET_STREAM_CHAT: (state, data) => {
        state.currentReceiveMessage.push({text: data.text, index: data.index});
        let message = state.currentReceiveMessage.sort((a, b) => a.index - b.index)
            .reduce((acc, item) => acc + item.text, '');

        if(data.index === 0) {
            data.text = message;
            state.chatList.push(data);
            state.isChatSent = false;
        } else {
            let length = state.chatList.length;
            let chatListElement = state.chatList[length -1];
            chatListElement.text = message;
        }
    },
    CLEAR_STREAM_CHAT: (state, data) => {
        state.currentReceiveMessage = []
    },
    UPDATE_SEND_STATUS: (state, data) => {
        state.isChatSent = data;
    }
}
